var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bell_svg__a)",
    fillRule: "evenodd",
    d: "M13.7 1.25H6.686L3.78 4.192v6.844L2.25 14.682v1.068h15.5v-1.068l-1.531-3.646v-6.81zM5.28 4.808 7.313 2.75h5.69l1.716 2.025v6.564l1.223 2.911H4.057l1.223-2.911zM12 17.25H8v1.5h4z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bell_svg__a",
    x1: 15.564,
    x2: -1.612,
    y1: 1.532,
    y2: 12.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgBell as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy42OTkyIDEuMjVINi42ODY1N0wzLjc4MTI1IDQuMTkyMVYxMS4wMzY0TDIuMjUgMTQuNjgyMlYxNS43NUgxNy43NVYxNC42ODIyTDE2LjIxODggMTEuMDM2NFY0LjIyNTA5TDEzLjY5OTIgMS4yNVpNNS4yODEyNSA0LjgwNzlMNy4zMTM0MyAyLjc1SDEzLjAwMzlMMTQuNzE4OCA0Ljc3NDkxVjExLjMzODZMMTUuOTQxNSAxNC4yNUg0LjA1ODQ2TDUuMjgxMjUgMTEuMzM4NlY0LjgwNzlaTTEyIDE3LjI1SDhWMTguNzVIMTJWMTcuMjVaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzQ1OF82MTU0NSkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zNDU4XzYxNTQ1IiB4MT0iMTUuNTY0MSIgeTE9IjEuNTMyMjYiIHgyPSItMS42MTIyMSIgeTI9IjEyLjg5MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMTI2MzAyIiBzdG9wLWNvbG9yPSIjRkY3ODgwIi8+CjxzdG9wIG9mZnNldD0iMC4zNzQ0IiBzdG9wLWNvbG9yPSIjMTVDRkU0Ii8+CjxzdG9wIG9mZnNldD0iMC42MjUxNTQiIHN0b3AtY29sb3I9IiMzQkYyQTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjg3NjM0OCIgc3RvcC1jb2xvcj0iIzY2NzVGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";